export enum YouSignResponseStatus {
  STARTED = 'started',
  SUCCESS = 'success',
  ERROR = 'error',
}
